// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles_placeholder__65q9e"};